import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails
} from '../../interfaces/apiInterfaces';

export class DriverResendInviteCommand extends IRequestCommand<
  IDriverResendInviteResponse,
  ErrorDetails,
  IDriverResendInviteParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'drivers/reSendEmailConfirmation/{driverUserId}';

  public override setParameters(
    params: IDriverResendInviteParameters
  ) {
    this._commandUrl = this._commandUrl.replace(
      '{driverUserId}',
      params.driverId.toString()
    );
    this._needAuthenticate = true;
    this._commandBody = params;
  }
}
export interface IDriverResendInviteParameters extends
  ICommandParameters {
  driverId: number;
}

export interface IDriverResendInviteResponse
  extends ICommandResponse { }


